<template>
    <div class="bg-white shadow-md mb-64 rounded mx-auto relative p-48 max-w-640">
        <popup-content :description="$t('free_trial.final.description')"
                       :progress="100"
                       :title="$t('free_trial.final.title')"
        >
            <div class="min-h-[30rem] w-400 mx-auto">
                <lottie-animation
                    :animationData="animation"
                    :autoPlay="true"
                    :loop="true"
                    :speed="1"
                />
            </div>
        </popup-content>

        <div class="flex items-center space-x-16 mt-24">
            <i18n-t keypath="free_trial.final.book_demo_description">
                <template #button>
                    <button class="text-highlight" role="button" @click="openMeeting">{{ $t('free_trial.final.personal_demo') }}</button>
                </template>
            </i18n-t>

            <simple-button class="whitespace-nowrap" look="secondary" @click="openMeeting">
                {{ $t('free_trial.final.book_demo') }}
            </simple-button>
        </div>

        <div v-show="showMeeting" class="bg-primary-20 mx-auto top-0 left-0 bottom-0 w-full h-screen fixed overflow-hidden z-10">
            <div class="h-full w-full overflow-y-auto flex items-center justify-center">
                <div class="max-w-960 w-full relative">
                    <button class="absolute top-0 right-0 mr-60 mt-20 group z-10" @click="closeMeeting">
                        <svg-icon class="max-w-24 max-h-24 text-primary-80 group-hover:text-semantic-error trans-ease" type="cancel"></svg-icon>
                    </button>

                    <div :data-src="hubspot_meeting" class="meetings-iframe-container"></div>
                </div>
            </div>
        </div>


        <div class="mt-48 flex justify-center space-x-20">
            <simple-button :disabled="performingRequest"
                           class="uppercase"
                           look="secondary"
                           @click="handlePreviousClick">
                {{ $t('general.back') }}
            </simple-button>

            <simple-button :disabled="performingRequest"
                           :loading="performingRequest"
                           class="uppercase w-240 whitespace-nowrap"
                           display="secondary"
                           look="primary"
                           @click="handleClick">
                {{ $t('free_trial.final.start_trial') }}
            </simple-button>
        </div>
    </div>
</template>

<script>
import * as companies from '../../../services/CompanyService';
import Company from '../../../models/Company';
import {normalizeJson} from '../../../../shared/helpers';
import {mapState} from 'pinia';
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../../../state/store';
import SimpleButton from '../SimpleButton.vue';
import PopupContent from './PopupContent.vue';
import SvgIcon from '../SvgIcon.vue';
import {LottieAnimation} from "lottie-web-vue";
import animation from '../../../../../../../public/interim/animations/finalstep.json';

export default {
    name: 'FinalStep',
    components: {PopupContent, SvgIcon, SimpleButton, LottieAnimation},
    props: {
        active_application: Object,
    },
    data() {
        return {
            performingRequest: false,
            showMeeting: false,
            animation
        };
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany', 'hubspot_meeting']),
    },
    methods: {
        handlePreviousClick() {
            //When you come from partner step go back to partners
            if (this.active_application) {
                return this.$emit('next', 9);
            }

            return this.$emit('previous');
        },
        handleClick() {
            this.performingRequest = true;

            companies.update(this.currentCompany.id, {data: {attributes: {in_setup: false}}})
                .then(result => {
                    this.performingRequest = false;

                    useRepo(Company).save(normalizeJson(result));

                    return this.$router.push('/');
                });
        },
        openMeeting() {
            this.showMeeting = true;
        },
        closeMeeting() {
            this.showMeeting = false;
        },
    },
    mounted() {
        let externalScript = document.createElement('script');
        externalScript.setAttribute('src', 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js');
        document.head.appendChild(externalScript);
    },
};
</script>
